import React from 'react';

import {
	Card,
	NewCheckoutCard,
} from '../styles';

const BraintreeUISelector = ({
	info,
	open,
	selected,
	outline,
	darkMode,
	medCheckout,
	isFollowupv2,
}) => {
	try{
		if (medCheckout) {
			return (
				<NewCheckoutCard medCheckout={medCheckout} selected={selected} outline={outline} onClick={open} darkMode={darkMode} style={{ width:'100%' }}>
					<div>
						<p>PayPal account {info.email ? `for ${info.email}` : ' '}</p>
					</div>
					{info &&
                <div className="edit" onClick={()=>{logAmplitudeEvent('submit_page',
                	{ submit_page_actions: 'update_payment_method' })}}>
                    Edit
                </div>
					}
				</NewCheckoutCard>
			);
		}
	} catch (err) {
		console.error(err);
	}
	return (
		<Card onClick={open} selected={selected} outline={outline} darkMode={darkMode}>
			<div>
				<div>PayPal</div>
				<div className="payment-method-icon paypal"></div>
			</div>
			<div>
				<div className="payment-account">
					{info.email || ' '}
				</div>
				{info &&
          <div className="edit">
            Edit
          </div>
				}
			</div>
		</Card>
	);
};

export default BraintreeUISelector;
